<template>
  <div class="evaluation-details-table">
    <div class="list">
      <div
        class="list-item"
        v-for="(item, index) in evaluationDetails"
        :key="index"
      >
        <div class="evaluation-category">
          <h5 class="title is-5 mb-3">
            <i class="fa fa-folder-open mr-2"></i>
            {{ item.name }}
          </h5>

          <div class="evaluation-rules">
            <div
              class="rule-item"
              v-for="(subItem, subIndex) in item.rules"
              :key="subIndex"
            >
              <div class="columns">
                <div class="column is-4">
                  <div class="rule-header">
                    <span class="icon">
                      <i
                        class="fa fa-check has-text-success"
                        v-if="subItem.result.check === true"
                      ></i>
                      <i
                        class="fa fa-times has-text-danger"
                        v-else-if="subItem.result.check === false"
                      ></i>
                      <i class="fa fa-question has-text-warning" v-else></i>
                    </span>
                    <span class="rule-name">{{ subItem.name }}</span>
                  </div>
                </div>

                <div class="column">
                  <RuleDataTable
                    v-if="hasRuleData(subItem)"
                    :data="subItem.result.data"
                  />
                  <div v-else class="no-data">
                    <em>{{ $t("no data available") }}</em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RuleDataTable from "./RuleDataTable.vue";

export default {
  name: "EvaluationDetailsTable",

  components: {
    RuleDataTable,
  },

  props: {
    evaluationDetails: {
      type: Array,
      required: true,
    },
  },

  methods: {
    /**
     * Check if rule has data to display
     */
    hasRuleData(subItem) {
      return (
        subItem.result?.data &&
        Array.isArray(subItem.result.data) &&
        subItem.result.data.length > 0
      );
    },
  },
};
</script>

<style scoped>
.title {
  color: hsl(0, 0%, 96%) !important;
}

.evaluation-category {
  border: 1px solid hsl(0, 0%, 42%);
  border-radius: 6px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  background-color: hsl(0, 0%, 14%);
}

.evaluation-rules {
  margin-top: 1rem;
}

.rule-item {
  background-color: hsl(0, 0%, 21%);
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  border: 1px solid hsl(0, 0%, 29%);
  transition: box-shadow 0.2s ease;
}

.rule-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  border-color: hsl(0, 0%, 42%);
}

.rule-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.rule-name {
  font-weight: 500;
  font-size: 0.95rem;
  color: hsl(0, 0%, 96%);
}

.no-data {
  color: hsl(0, 0%, 71%);
  font-style: italic;
  padding: 0.5rem 0;
}

.icon {
  font-size: 1.1rem;
}

.has-text-success {
  color: hsl(153, 53%, 53%) !important;
}

.has-text-danger {
  color: hsl(348, 86%, 61%) !important;
}

.has-text-warning {
  color: hsl(44, 100%, 77%) !important;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}
</style>
